export default {
  name: 'PageNavLayoutCpt',
  props: {
    showNavMargin: Boolean
  },
  data() {
    return {
      pageTitle: this.$route.name
    };
  },
  mounted() {}
};